jQuery(document).ready(function($) {
    
    // Unsticky sidebar if taller than window height
	//----------------------------------------------
    function unstickySidebar() {
		var windowHeight = $(window).height();
		
		if ($('#pageSidebar').outerHeight() >= windowHeight) {
			$('#pageSidebar').addClass('position-relative');
		} else {
			$('#pageSidebar').removeClass('position-relative');
		}
	}

	// Window listeners	
	$(window).resize(function(){
		unstickySidebar();
	});
    
    // have to initialize this after the accordion nav menu has been expanded
    $(window).on("load", function() {
        setTimeout(unstickySidebar, 500);
    });

});
